import { BaseResource, NestedResourceNode, ResourceAction } from "@legacy-megarax/rest-resource";
import { MSerializers } from "@legacy-megarax/serializers";

export interface ProfileDto {
  firstName: string;
  lastName: string;
  pictureUrl: string | null;
}

export const profileDtoSerializer = MSerializers.object<ProfileDto>({
  firstName: MSerializers.string,
  lastName: MSerializers.string,
  pictureUrl: MSerializers.string.nullable(),
});

const isAllowed = ResourceAction({
  name: "isAllowed",
  method: "get",
  querySerializer: MSerializers.object({
    action: MSerializers.string,
  }),
  responseSerializer: MSerializers.boolean,
});

export const meResource = BaseResource(["iam", "me"], {
  user: ResourceAction({
    name: "user",
    method: "get",
    path: "",
    responseSerializer: MSerializers.object({
      id: MSerializers.integer,
      groups: MSerializers.array(
        MSerializers.object({
          uuid: MSerializers.string,
          name: MSerializers.string,
        }),
      ),
      email: MSerializers.string,
    }),
  }),
  isAllowed,
  isAllowedEach: ResourceAction({
    name: "isAllowedEach",
    method: "post",
    requestBodySerializer: MSerializers.array(MSerializers.string),
    responseSerializer: MSerializers.mapObject(MSerializers.boolean),
  }),

  profile: NestedResourceNode("profile", {
    update: ResourceAction({
      name: "updateProfile",
      method: "put",
      requestBodySerializer: MSerializers.object<ProfileDto>({
        firstName: MSerializers.string,
        lastName: MSerializers.string,
        pictureUrl: MSerializers.string.nullable(),
      }),
      path: "",
    }),
  }),
});
